import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container } from 'reactstrap';
import { userContextActions } from '../../store/userContextStore'
import { withLocalize, Translate } from "react-localize-redux";
import Message from '../common/message';
import BbInput from '../styling/bbInput';
import { Formik, Field, Form } from 'formik';
import SelectOption from '../searchSections/selectOption';
import classnames from 'classnames';
import { apiPost, apiGet, hasPermission } from '../../store/apiWrapper';
import * as Yup from '../common/Yup';
import { Link } from "react-router-dom";
import { pick } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './hyperlinkGenerator.scss'


const TARGET_TYPES = {
    none: "",
    login: "Login",
    gr: "GR",
    rc: "RC",
    sr: "SR",
    cd: "CD",
    bb: "BB",
    rf: "RF",
    eg: "EG",
    search: "Search",
};

const KEYS = {
    country: 'country',
    username: 'username',
    output: 'output',
    validity: 'validity',
    report: 'report',
    language: 'language',
    target: "target"
};

class HyperlinkGeneratorComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, token: null, isLoading: false, maximalValidity: 87670 };
        this.getDefaultValues();
    }


    getDefaultValues = () => {
        apiGet(`${window.babylonApiUrl}/api/hyperlink/generate-token`, null,
        (data) => {
            if (data.data.isSuccess) {
                this.setState({ maximalValidity: data.data.validityMaxValue });
            }
            else {
                this.setState({ error: data.data.message, isLoading: false })
            }
        },
        (err) => { this.setState({ error: err.error.message, isLoading: false }); });
    }

    handleSubmit = (values, setFieldValue) => {
        this.setState({ error: null, token: null, isLoading: true })
        apiPost(`${window.babylonApiUrl}/api/hyperlink/generate-token`, null,
            {
                [KEYS.country]: parseInt(values[KEYS.country]),
                [KEYS.username]: values[KEYS.username],
                [KEYS.output]: values[KEYS.output],
                [KEYS.validity]: parseFloat(values[KEYS.validity]),
                [KEYS.report]: values[KEYS.report],
                [KEYS.language]: values[KEYS.language],
                [KEYS.target]: values[KEYS.target]
            },
            (data) => {
                if (data.data.isSuccess) {
                    this.setState({ token: data.data.token, isLoading: false });
                }
                else {
                    this.setState({ error: data.data.message, isLoading: false })
                }
            },
            (err) => { this.setState({ error: err.data.error.message, isLoading: false }); });
    }

    showMessage = (type, message) => {
        if (message === null || message === undefined) {
            return "";
        }
        return (<div className="column"><Message type={type} message={typeof(message) === "string" ? this.checkTranslation(this.props.translate(message)) : message} style={{ fontSize: '.8em' }} /></div>);
    };

    checkTranslation = (translation) => {
        if (translation.startsWith('-') && translation.endsWith('-'))
            return translation.substring(1, translation.length - 1);
        return translation;
    }

    loginSubmitDisabled = () => this.state.isLoading;

    getCountryLabels = () => {
        return [
            { label: "Common.CzechRepublic", value: '1' },
            { label: "Common.SlovakRepublic", value: '2' }
        ];
    }

    getOutputLabels = () => {
        return [
            { label: "Hyperlink.Output.Full", value: "Full" },
            { label: "Hyperlink.Output.Limited", value: "Limited" }
        ];
    }

    getTargetSKListItems = () => [
        { key: -1, value: TARGET_TYPES.none, label: "" },
        { key: -2, value: TARGET_TYPES.login, label: TARGET_TYPES.login },
        { key: -3, value: TARGET_TYPES.gr, label: TARGET_TYPES.gr },
        { key: -4, value: TARGET_TYPES.rc, label: TARGET_TYPES.rc },
        { key: -4, value: TARGET_TYPES.cd, label: TARGET_TYPES.cd },
        { key: -4, value: TARGET_TYPES.bb, label: TARGET_TYPES.bb },
        { key: -4, value: TARGET_TYPES.sr, label: TARGET_TYPES.sr },
        { key: -4, value: TARGET_TYPES.rf, label: TARGET_TYPES.rf },
        { key: -5, value: TARGET_TYPES.search, label: TARGET_TYPES.search }
    ];

    getTargetCZListItems = () => [
        { key: -1, value: TARGET_TYPES.none, label: "" },
        { key: -2, value: TARGET_TYPES.login, label: TARGET_TYPES.login },
        { key: -3, value: TARGET_TYPES.gr, label: TARGET_TYPES.gr },
        { key: -4, value: TARGET_TYPES.rc, label: TARGET_TYPES.rc },
        { key: -4, value: TARGET_TYPES.sr, label: TARGET_TYPES.sr },
        { key: -4, value: TARGET_TYPES.rf, label: TARGET_TYPES.rf },
        { key: -5, value: TARGET_TYPES.search, label: TARGET_TYPES.search }
    ];

    getLanguagesListItems = () => {
        var languageList = [];
        this.props.languages.map(language =>
            languageList = languageList.concat({ key: language.code, value: language.code, label: language.name })

        )
        return languageList;
    }

    createValidationSchema = () => {
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");
        const schema = {
            'username': Yup.string().trim().required(wrongInputMsg),
            'target': Yup.string().trim().required(wrongInputMsg),
            'report': Yup.string().trim().when('target',{
                is: target =>  { 
                    if (target === TARGET_TYPES.login || target === TARGET_TYPES.search) return true;
                    return false;
                 } ,
                then: Yup.string().notRequired(),
                otherwise: Yup.string().required(wrongInputMsg).matches(/\d+/, { message: wrongInputMsg })
            })
        };

        return Yup.object().shape(pick(schema, ['report', 'target', 'username']));
    }

    validateTime = (value, setFieldValue, target) => {
        let currentVal = parseInt(value);

        if (!this.isNullOrUndefined(currentVal) && !this.isNullOrUndefined(this.state.maximalValidity) && !isNaN(this.state.maximalValidity) && currentVal > this.state.maximalValidity) {
            currentVal = this.state.maximalValidity;
        }
        setFieldValue(target, this.isNullOrUndefined(currentVal) ? "" : currentVal);
    }

    isNullOrUndefined = (obj) => {
        return obj === null || obj === undefined;
    }

    translateErrorItem = (item) =>
        (item === null || item === null || item.length < 1) ? null : this.props.translate(`Hyperlink.${item[0].toUpperCase()}${item.slice(1)}`)


    renderForm = () => {

        const languagesListItems = this.getLanguagesListItems();
        const targetCZListItems = this.getTargetCZListItems();
        const targetSKListItems = this.getTargetSKListItems();
        return (
            <div className={classnames("justify-content-center", { 'vertical-center': localStorage.locales_login === 'tree' })}>
                <div className="columns is-centered">
                    {hasPermission(null, 'TokenGeneratorForm') &&
                    <div className={classnames("column", "bb-generate-hyperlink-box")}>
                        <h4 className="bb-login-caption has-text-centered">{this.props.translate("Hyperlink.Generate.Token")}</h4>
                        <div className="progress-wrapper">
                            <div className='bb-login-progress' />
                        </div>

                        <div className="bb-generate-hyperlink-body">
                            <Formik
                                ref={(el) => this.formRef = el}
                                enableReinitialize={true}
                                validationSchema={this.createValidationSchema()}
                                validateOnChange={false}
                                validateOnBlur={false}
                                initialValues={{
                                    [KEYS.country]: '1',
                                    [KEYS.username]: this.props.authentication.profile.username,
                                    [KEYS.output]: hasPermission(null, 'TokenGeneratorLimited') ? 'Limited' : 'Full',
                                    [KEYS.validity]: this.state.maximalValidity,
                                    [KEYS.report]: '',
                                    [KEYS.language]: 'sk-SK',
                                    [KEYS.target]: ""
                                }}
                                onSubmit={(values, { setFieldValue, setSubmitting }) => {
                                    setSubmitting(false);
                                    this.handleSubmit(values, setFieldValue);
                                }}
                            >
                                {({ values, setFieldValue, errors }) => (
                                    <Form autoComplete="off">
                                        {Object.keys(errors).length > 0 && <div className="column">
                                            <Message type="error" message={this.props.translate("Error.InvalidParams")}>
                                                <ul style={{ listStyleType: "disc" }}>
                                                    {Object.keys(errors).map(k => <li key={k} style={{ marginLeft: "3em" }}>{this.translateErrorItem(k)}</li>)}
                                                </ul>
                                            </Message>
                                        </div>}
                                        {(this.state.error && Object.keys(errors).length === 0) &&
                                            this.showMessage('warning', this.state.error)
                                        }
                                        {(this.state.token && Object.keys(errors).length === 0) &&
                                            this.showMessage('success', <span>
                                                <span>{this.props.translate("Hyperlink.Generate.Success")} </span>
                                                <Link to={`/hyperlink/token/${this.state.token}`}>
                                                    {window.location.href.replace(/generate-/,'')}/{this.state.token}
                                                </Link>
                                            </span>)
                                        }
                                        <BbInput name="username" type="text" label={this.props.translate('Hyperlink.Username')} placeholder={{ type: 'column' }} 
                                            disabled={!hasPermission(null, 'TokenGeneratorAdmin')} useDefaultColorOnDisabled={true} />
                                        <BbInput type="select-noformik" label={this.props.translate("Hyperlink.Language")}
                                            placeholder={{ type: "column" }}
                                            options={languagesListItems}
                                            formatOptionLabel={SelectOption}
                                            value={languagesListItems.find(f => f.value === values[KEYS.language])}
                                            onChange={(e) => setFieldValue(KEYS.language, e.value)}
                                        />
                                        <BbInput type='radio' label={this.props.translate('Hyperlink.Country')} placeholder={{ type: 'column' }}
                                            options={this.getCountryLabels()}
                                            idFormat={(val) => `$radio-token-generator-country-${val}`}
                                            checkedValue={values[KEYS.country]}
                                            callback={(val) => setFieldValue(KEYS.country, val)}
                                        />
                                        <BbInput type="select-noformik" label={this.props.translate("Hyperlink.Target")}
                                            placeholder={{ type: "column" }}
                                            options={values[KEYS.country] == 'SK' ? targetSKListItems : targetCZListItems}
                                            formatOptionLabel={SelectOption}
                                            value={(values[KEYS.country] == 'SK' ? targetSKListItems : targetCZListItems).find(f => f.value === values[KEYS.target])}
                                            onChange={(e) => setFieldValue(KEYS.target, e.value)}
                                        />

                                        <BbInput type='radio' label={this.props.translate('Hyperlink.Output')} placeholder={{ type: 'column' }}
                                            options={this.getOutputLabels()}
                                            idFormat={(val) => `$radio-token-generator-output-${val}`}
                                            checkedValue={values[KEYS.output]}
                                            callback={(val) => { if (hasPermission(null, 'TokenGeneratorFull') && hasPermission(null, 'TokenGeneratorLimited')) { setFieldValue(KEYS.output, val)}}}
                                            disabled={!hasPermission(null, 'TokenGeneratorFull') || !hasPermission(null, 'TokenGeneratorLimited')}
                                            useDefaultColorOnDisabled={true}
                                        />

                                        <div className="columns">
                                            <div className="column column bb-input-label-column is-one-third">
                                                <div className="vertically-centered">
                                                        <span><Translate id="Hyperlink.Validity" /></span>
                                                </div>
                                            </div>
                                            <div className="column bb-input-column is-two-thirds">
                                            <Field
                                                className="bb-input-expanded input form-control"
                                                label={this.props.translate('Hyperlink.Validity')}
                                                placeholder={{ type: 'column' }}  
                                                max={this.state.maximalValidity}
                                                type="number"
                                                name="validity"
                                                onChange={e => this.validateTime( e.target.value, setFieldValue, KEYS.validity)}
                                            />
                                        </div>
                                            </div>

                                        <BbInput name="report" type="text" label={this.props.translate('Hyperlink.Report')} placeholder={{ type: 'column' }}  />

                                        <div className="bb-group" style={{ display: "flex", justifyContent: "center" }}>
                                            <button
                                                className={classnames('bb-button gradient-1', {'is-square': localStorage.locales_button_style === 'square' })}
                                                type="submit" disabled={this.loginSubmitDisabled(values)}>
                                                {this.state.isLoading ? <FontAwesomeIcon icon="cog" spin /> : this.props.translate("Hyperlink.Generate.Token")}
                                            </button>
                                        </div>
                                        <div className="bb-group" style={{
                                            fontSize: '.9em',
                                            textAlign: 'center',
                                            paddingTop: '1.5em'
                                        }}>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                    }
                    {!hasPermission(null, 'TokenGeneratorForm') &&
                        this.showMessage('warning', 'Hyperlink.Generator.Unauthorized')
                    }
                </div>
            </div>
        )
    }




    render() {
        return (
            <React.Fragment>
                <div className="fake-div" />
                <div className="d-flex all-father" style={{ width: "100%" }}>
                    <main role="main" className="flex-shrink-0">
                        {(this.props.error && !this.props.areReportSectionsDisplayed) ?
                            <Container style={{ paddingTop: "1em" }}><Message type='warning' message={<Translate id={this.props.error} options={{ renderInnerHtml: true }} />} /></Container> :
                            <Container style={{ paddingLeft: "0", paddingRight: "0" }} fluid={true}>

                                <div className='app-screen app-loading-screen blue-background'>
                                    {this.renderForm()}
                                </div>
                            </Container>
                        }
                    </main>
                </div>
            </React.Fragment>);
    }

}
export default withLocalize(connect(
    state => state.userContext,
    dispatch => bindActionCreators(userContextActions, dispatch)
)(HyperlinkGeneratorComponent));
